<div class="h-screen flex flex-col">
  <nav
    [ngClass]="isNavZindex ? 'z-[11]' : ''"
    class="top-0 relative dark-purple"
  >
    <div
      class="absolute left-0 bottom-0 top-0 bg-[#24165A] menu-mask"
      *ngIf="showMenuSwitcher"
    ></div>
    <div class="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center h-full flex-1 w-full">
          <div
            [ngStyle]="{
              'background-color': showMenuSwitcher ? '#24165A' : undefined,
              'border-radius': showMenuSwitcher
                ? '0px 200px 200px 0px'
                : undefined,
              padding: showMenuSwitcher ? '0px 10px 0px 0px' : undefined,
            }"
            class="flex-shrink-0 flex gap-x-1 h-full items-center relative z-[999]"
          >
            <a
              class="flex items-center"
              [routerLink]="menuModeGroupsRoutes[menuMode]"
            >
              <svg-icon
                [svgClass]="'h-8 text-white'"
                src="assets/svg/logo-new.svg"
              ></svg-icon>
            </a>
            <div *ngIf="showMenuSwitcher" #menuSwitcher class="relative">
              <div>
                <button
                  (click)="menuSwitcherOpen = !menuSwitcherOpen"
                  class="max-w-xs flex items-center apai-menu-btn"
                  id="menu-switcher"
                  aria-label="Menu switcher"
                  aria-haspopup="true"
                >
                  <p class="ml-1 apai-name-btn text-white lg:block">
                    {{ getMenuModeLabel(menuMode) }}
                  </p>
                  <svg
                    class="hidden flex-shrink-0 h-5 w-5 lg:block text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>
              <div
                *ngIf="menuSwitcherOpen"
                [@inOutAnimation]
                class="absolute left-0 mt-[14px] w-[170px] rounded-b-[16px] shadow-[0px_2px_14px_0px_#00000024] z-40 border border-[#F1F1FF]"
              >
                <div class="p-2 rounded-b-md bg-white flex flex-col gap-y-2">
                  <div
                    *ngFor="let mode of availableMenuModes"
                    (click)="onSwitchMenu(mode)"
                    class="text-[14px] text-[#000000DE] font-[500] cursor-pointer flex items-center justify-between"
                  >
                    {{ getMenuModeLabel(mode) }}
                    <svg-icon
                      *ngIf="menuMode === mode"
                      src="assets/heroicons/outline/check.svg"
                      svgClass="w-4 h-4 text-green-500"
                    ></svg-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="loggedIn | async" class="hidden md:block w-full">
            <ng-container [ngSwitch]="menuMode">
              <div
                *ngSwitchCase="'vat'"
                class="ml-1 flex items-baseline w-full"
              >
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_INVOICES]"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                  [routerLink]="['/app', 'expenses', 'expenses']"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="invoices-nav-btn"
                >
                  Invoices
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_ENTITIES]"
                  [routerLink]="['/app', 'groups']"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="entities-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Companies
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_USERS]"
                  [routerLink]="['/app', 'users']"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="users-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Users
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_CLAIMS]"
                  [routerLink]="['/app', 'claims']"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="claims-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Claims
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_IMAGE_TO_LINE]"
                  data-cy="image-to-line-nav-btn"
                  [routerLink]="['/app', 'image-to-line']"
                  [routerLinkActive]="['name-btn-active']"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Image To Line
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_VENDORS]"
                  data-cy="vendors-nav-btn"
                  [routerLink]="['/app', 'expenses', 'suppliers']"
                  [routerLinkActive]="['name-btn-active']"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Vendors
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_DASHBOARD]"
                  data-cy="dashboard-nav-btn"
                  [routerLink]="['/app', 'dashboard']"
                  [routerLinkActive]="['name-btn-active']"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Dashboard
                </a>
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_FEES_CONFIGURATION]"
                  data-cy="fees-nav-btn"
                  [routerLink]="['/app', 'fees-configuration']"
                  [routerLinkActive]="['name-btn-active']"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Fees Configuration
                </a>
                <!-- *ngxPermissionsOnly="[permissions.SHOW_APAI]" -->
                <a
                  *ngIf="false"
                  data-cy="fees-nav-btn"
                  [routerLink]="['/app', 'apai']"
                  [routerLinkActive]="['name-btn-active']"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  APAI
                </a>

                <ng-container *ngIf="canUseDataManagement">
                  <a
                    *ngxPermissionsOnly="[permissions.SHOW_DATA_MANAGEMENT]"
                    data-cy="data-management-nav-btn"
                    [routerLink]="['/app', 'data-management']"
                    [routerLinkActive]="['name-btn-active']"
                    class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                  >
                    Data Management
                  </a>
                </ng-container>
              </div>
              <div
                *ngSwitchCase="'apai'"
                class="ml-1 flex items-baseline w-full"
              >
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_APAI_DASHBOARD]"
                  [routerLink]="['/app', 'apai', 'dashboard']"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="apai-dashboard-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Dashboard
                </a>

                <a
                  *ngxPermissionsOnly="[permissions.SHOW_APAI_REPORT]"
                  [routerLink]="['/app', 'apai', 'reports']"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="claims-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Reports
                </a>
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_APAI_COMPANIES]"
                  [routerLink]="menuModeGroupsRoutes[menuMode]"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="entities-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Companies
                </a>
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_USERS]"
                  [routerLink]="menuModeUsersRoutes[menuMode]"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="users-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Users
                </a>
              </div>
              <div
                *ngSwitchCase="'einvoicing'"
                class="ml-1 flex items-baseline w-full"
              >
                <a
                  [routerLink]="['/app', 'e-invoicing']"
                  [routerLinkActive]="['name-btn-active']"
                  [routerLinkActiveOptions]="{ exact: true }"
                  data-cy="e-invoicing-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Invoicing
                </a>
                <ng-container *ngIf="isWay2InvoiceMerged">
                  <a
                    *ngxPermissionsOnly="[permissions.SHOW_APAI_DASHBOARD]"
                    [routerLink]="['/app', 'apai', 'dashboard']"
                    [routerLinkActive]="['name-btn-active']"
                    data-cy="apai-dashboard-nav-btn"
                    class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                  >
                    Dashboard
                  </a>
                  <a
                    *ngxPermissionsOnly="[permissions.SHOW_APAI_REPORT]"
                    [routerLink]="['/app', 'apai', 'reports']"
                    [routerLinkActive]="['name-btn-active']"
                    data-cy="apai-reports-nav-btn"
                    class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                  >
                    Reports
                  </a>
                </ng-container>
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_ENTITIES]"
                  [routerLink]="menuModeGroupsRoutes[menuMode]"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="entities-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Companies
                </a>
                <a
                  *ngxPermissionsOnly="[permissions.SHOW_USERS]"
                  [routerLink]="menuModeUsersRoutes[menuMode]"
                  [routerLinkActive]="['name-btn-active']"
                  data-cy="users-nav-btn"
                  class="ml-2 transition duration-150 ease-in-out text-white name-btn"
                >
                  Users
                </a>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="hidden md:block">
          <div class="ml-1 flex items-center">
            <!--             <button class="p-1 border-2 border-transparent text-yellow-300 rounded-full hover:text-white focus:outline-none focus:text-white focus:bg-gray-700">
              <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button> -->

            <div *ngIf="loggedIn | async" #clickOutside class="ml-1 relative">
              <div>
                <button
                  (click)="openMenu = !openMenu"
                  class="max-w-xs flex items-center name-btn"
                  id="user-menu"
                  aria-label="User menu"
                  aria-haspopup="true"
                >
                  <p class="ml-1 name-btn text-white lg:block">
                    {{ fullname$ | async }}
                  </p>
                  <svg
                    class="hidden flex-shrink-0 h-5 w-5 lg:block text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>

              <div
                *ngIf="openMenu"
                [@inOutAnimation]
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg z-40"
              >
                <div
                  class="py-1 rounded-md bg-white ring-1 ring-black ring-opacity-5"
                >
                  <a
                    [routerLink]="'/auth/change-password'"
                    (click)="openMenu = false"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >Change Password</a
                  >
                  <a
                    (click)="signOut(); openMenu = false"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >Sign out</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="-mr-2 flex md:hidden">
          <button
            (click)="open = !open"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
          >
            <svg
              class="h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                [ngClass]="{ hidden: open, 'inline-flex': !open }"
                class="inline-flex"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                [ngClass]="{ hidden: !open, 'inline-flex': open }"
                class="hidden"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </nav>

  <main class="flex-1 overflow-auto relative">
    <!-- <div class="max-w-screen-2xl mx-auto py-6 sm:px-6 lg:px-8"> -->
    <app-loader *ngIf="loading$ | async" />
    <router-outlet></router-outlet>

    <!-- </div> -->
  </main>

  <!-- <span
    *ngIf="version"
    class="absolute bottom-0 m-2 left-0 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-blue-100 text-blue-800"
  >
    {{ version }}, {{ role }}, {{ expires$ | async }}
  </span> -->
</div>
